import { CustomerSymbolGroups } from '@src/containers/Dealer/CustomerSymbolGroups/CustomerSymbolGroups';
import type { CustomerSymbolGroupsPanelConfig } from '@src/types/LayoutConfig';
import type { LayoutPanelProps } from '../../types';
import { EntityAdminPanelShell } from './EntityAdminPanelShell';

export function CustomerSymbolGroupsPanel({ api, params }: LayoutPanelProps<CustomerSymbolGroupsPanelConfig>) {
  return (
    <EntityAdminPanelShell
      panelApi={api}
      panelTabs={params.tabs}
      panelBlottersState={params.blotterTablesState}
      data-testid="customer-symbol-groups-panel"
    >
      <CustomerSymbolGroups />
    </EntityAdminPanelShell>
  );
}
